import { Component, OnInit } from '@angular/core';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { RequestButtonTypes } from 'src/app/common/components/request-button/request-button.component';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/common/utils';
import { BaseView } from 'src/app/view/base-view';
import { CamposApiService } from 'src/app/service/api/campos-api.service';
import { StorageManager } from '../../../../common/storage-manager.class';
import { Filtering } from 'src/app/service/filtering/filtering';

import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { TreeNode } from 'primeng/api';
import { CamposEnvironmentDefinition } from './environment-variables';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { CamposFormDefinition } from './campos-form/form-definition';
@Component({
    selector: 'app-campos',
    standalone: false,
    templateUrl: './campos.component.html',
    styleUrls: ['./campos.component.scss']
})
export class CamposComponent extends BaseView<ParcelasModel> implements OnInit {
    public form!: CamposFormDefinition;
    public env: CamposEnvironmentDefinition = new CamposEnvironmentDefinition();
    
    public getRequest: RequestHandler<ParcelasModel[]> = this.camposApi.campos.GET;
    public deleteRequest: RequestHandler<ParcelasModel> = this.camposApi.campos.DELETE;
    public menuItemId = 'campos';

    public filter: Filtering<ParcelasModel> = new Filtering<ParcelasModel>();
    public showAllCampos = false;

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};
    public override model = {} as ParcelasModel;

    public btnAnadir = 'Añadir Campo';


    public cols: ColInterface[] = [
        {field: 'nombre', header: 'Nombre', filter: ''},
        {field: 'cultivo', header: 'Cultivo', filter: ''},
        {field: 'variedad', header: 'Variedad', filter: ''},
        {field: 'superficie_sigpac', header: 'Sup.\xa0Sigpac', filter: ''},
        {field: 'superficie_cultivada', header: 'Sup.\xa0Cultivada', filter: ''},
        {field: 'poligono', header: 'Polígono', filter: ''},
        {field: 'numero', header: 'Nº\xa0parcela', filter: ''},
        {field: 'plantas', header: 'Nº\xa0Árboles/Plantas', filter: ''},
        {field: 'usuario_nombre', header: 'Usuario', filter: '', visible: this.env.rol === 'admin'},
    ];

    constructor(public fincasApi: FincasApiService,
        public camposApi: CamposApiService,
        private dashboard: DashboardService,
        private router: Router) {
        super(dashboard, camposApi.campos.GET, camposApi.campos.DELETE);
    }

    ngOnInit() {
        this.showAllCampos = Utils.initShowAll('showAllcampos');
        this.initFilter();
        this.dashboard.setMenuItem(this.menuItemId);
    }

    public add() {
        this.router.navigate(['dashboard', 'crear-campo']);
    }

    public edit(data: FincasModel) {
        this.router.navigate(['dashboard', 'editar-campo', data.id]);
    }

    public override show(modal: string, data: ParcelasModel) {
        super.show(modal, data);
        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        
        this.form = new CamposFormDefinition(formType, data as Record<string, string>, null);
        
        const elements = document.getElementsByClassName('ui-dialog-content ui-widget-content');
        setTimeout(() => {
            if (elements[0]) {
                elements[0].scrollTop = 0;
            }
        }, 100);
    }

    public globalConditionalStyle(value: string): ColStylesInterface {
        if (Utils.isNumber(value)) {
            return {
                textAlign: 'right',
                paddingRight: '40px',
            };
        }
        return {};
    }

    public globalVisualTransform(value: string, col: ColInterface) {
        if (Utils.isNumber(value)) {
            if (col.field === 'superficie') {
                return Utils.decimalFormat(value.replace(',', '.'), 2).replace('.', ',');
            } else if (col.field === 'plantas') {
                return Utils.decimalFormat(value, 0);
            }
        }
        return value;
    }

    public filterCampos() {
        this.filter.filter();
    }
    
    public changeShowAll(){
        sessionStorage.setItem('showAllcampos', this.showAllCampos === true ? 'true' : 'false' );
    }
    
    private initFilter() {
        this.filter.addFilter((data: TreeNode<ParcelasModel>[] | void) => (data || [])
            .filter((it: TreeNode<ParcelasModel>) => it)
            .filter((it: TreeNode<ParcelasModel>) => !this.showAllCampos 
                ? [(it as ParcelasModel).id_usuario].includes(StorageManager.getUser().id)
                : true)
        );
    }
}
